// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/assets/canopy_l.png", import.meta.url);
// Module
var code = `<div class="drawable" data-safe-area-root>
	<div class="profile">
		<div class="username--container">
			<img class="canopy-img" src="${___HTML_LOADER_IMPORT_0___}" ng-if="data.template === 'official'" />
			<p ng-if="data.template === 'official'" class="username">@{{data.username}}</p>
		</div>
		<div class="rf2026-ig-badge">
			<img data-ng-src="/assets/ig_icon.png" class="rf2026-ig-icon" />
			<span class="rf2026-ig-handle">@roskildefestival</span>
		</div>
		<div class="post--container" ng-bind-html="captionHtml">
		</div>
	</div>
	<div class="frame"></div>
</div>`;
// Exports
export default code;